import React, { useState } from 'react';
import styles from '../../styles/components/Content.module.css';

const tiles = [
  { id: 1, title: 'Kids', articles: ['Hangry Kids', 'Healthy Smoothie Ideas'] },
  { id: 2, title: 'Parenting', articles: ['Settling Sibling Disputes', 'Parenting Tips for Dual Working Parents'] },
  { id: 3, title: 'Events', articles: ['DIY Home Decor', 'Hosting Holiday Parties'] },
  { id: 4, title: 'Travel', articles: ['Keeping Kids Busy in the Car', 'Outdoor Adventures'] },
];

function Content() {
  const [activeTile, setActiveTile] = useState(null);

  const handleTileClick = (id) => {
    setActiveTile(activeTile === id ? null : id);
  };

  return (
    <section id="content" className={styles.contentSection}>
      <h2 className={styles.sectionTitle}>Explore Our Content</h2>
      <div className={styles.tilesContainer}>
        {tiles.map((tile) => (
          <div key={tile.id} className={styles.tileWrapper}>
            <div
              className={`${styles.tile} ${activeTile === tile.id ? styles.active : ''}`}
              onClick={() => handleTileClick(tile.id)}
            >
              <h3>{tile.title}</h3>
            </div>
            <div className={`${styles.articleList} ${activeTile === tile.id ? styles.show : ''}`}>
              {tile.articles.map((article, index) => (
                <div key={index} className={styles.articleCard}>
                  {article}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Content;